import type { MonospacePage, MonospacePageSection, MonospaceSpace } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import * as z from 'zod/v4-mini';
import { nonEmptyString } from '#layers/base/public';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

export const Space = withItemType<MonospaceSpace>().defineCollection({
	name: 'MonospaceSpace',
	scopeId: MONOSPACE_SCOPE_ID,
	formSchema: {
		create: z.object({
			title: z.string().check(z.minLength(1)),
			icon: z.string(),
		}),
		update: z.partial(z.object({
			title: z.string().check(z.minLength(1)),
			icon: z.string(),
		})),
	},
	meta: {
		defaultFields: ['id', 'title', 'route', 'icon', 'sort'],
	},
});

export const Page = withItemType<MonospacePage>().defineCollection({
	name: 'MonospacePage',
	scopeId: MONOSPACE_SCOPE_ID,
	formSchema: {
		create: z.object({
			title: nonEmptyString(),
		}),
		update: z.partial(z.object({
			title: nonEmptyString(),
			icon: z.string(),
			iconColor: z.nullable(z.string()),
			description: z.string(),
		})),
	},
	meta: {
		defaultFields: ['id', 'title', 'route', 'icon', 'iconColor', 'sort', 'isFullWidth', 'isHidden', 'spaceId', 'sectionId', 'type', 'collectionId', 'intent', 'overridePage'],
		relationsWithConstraint: new Set(['space', 'section', 'collection']),
		connect: {
			collectionId: ['collection', 'id'],
		},
	},
});

export const PageSection = withItemType<MonospacePageSection>().defineCollection({
	name: 'MonospacePageSection',
	scopeId: MONOSPACE_SCOPE_ID,
	formSchema: {
		create: z.object({
			title: z.string().check(z.minLength(1)),
		}),
		update: z.partial(z.object({
			title: z.string().check(z.minLength(1)),
		})),
	},
	meta: {
		defaultFields: ['id', 'title', 'sort', 'spaceId'],
		connect: {
			spaceId: ['space', 'id'],
		},
	},
});
